import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from 'src/app/types';

@Injectable()
export class LoginInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Check if the request URL matches the login endpoint
    // We check for the relative path or if it contains the login path
    if (request.url.includes('authentication/login')) {
       // Clone the request and modify the body
      if (request.body && typeof request.body === 'object') {
        const body = request.body as any;
        if(body.deviceInfo) {
             const modifiedBody = {
            ...body,
            deviceInfo: {
                ...body.deviceInfo,
                platform: 'web'
            }
        };

        const clonedRequest = request.clone({
            body: modifiedBody
        });
        return next.handle(clonedRequest);
        }
       
      }
    }
    return next.handle(request);
  }
}
